import styled from "styled-components";
import Box from "@mui/material/Box";
import { RowSpaceBetween } from "components/common";

const INPUT_HEIGHT = "70px";
const Container = styled.div`
  color: red;
  background-color: read;

  font-size: 28px;

  label {
    margin-bottom: 5px;
    font-weight: bold;
  }

  .MuiOutlinedInput-root.filter {
    width: 100%;
    min-height: ${INPUT_HEIGHT};
    height: 10vh;
  }

  .MuiOutlinedInput-root.filter .MuiOutlinedInput-input {
    position: absolute;
    top: 0;
    max-width: 100%;
    height: 100%;
    padding: 0;
  }
`;

const Button = styled.div`
  float: right;
  color: white;
  background-color: grey;
`;

const MultiLabelContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-height: calc(${INPUT_HEIGHT} - 20px);
  overflow-y: auto;
  max-width: 95%;
  padding: 1rem;
`;

const FilterContainer = styled(Box)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border: 2px solid #000;
  box-shadow: 0px 11px 15px -7px rgb(0 0 0 / 20%),
    0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%);
  width: 60vw;
  padding: 1em;
  padding-top: 2em;
`;

const FilterHeader = styled(RowSpaceBetween)`
  position: absolute;
  right: 1em;
  top: 0;
  padding-top: 1em;
  left: 1em;
  background-color: #fff;
  z-index: 1;
`;

const ScrollContainer = styled(Box)`
  max-height: calc(84% + 20px);
  overflow-y: auto;
`;

const ApplyClearButtonContainer = styled.div`
  float: right;
  position: fixed;
  bottom: 0;
  right: 0;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1em;
  padding-bottom: 1em;
  padding-right: 1em;
  z-index: 1;

  .MuiButton-root {
    color: white;
    // background-color: grey;
    width: 80px;
  }
`;

const SaveApplyClearButtonContainer = styled.div`
  float: left;
  position: fixed;
  bottom: 0;
  left: 0;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1em;
  padding-bottom: 1em;
  padding-left: 1em;
  z-index: 1;

  .MuiButton-root {
    color: white;
    // background-color: grey;
    width: 180px;
  }
`;

export {
  Container,
  Button,
  MultiLabelContainer,
  FilterContainer,
  ScrollContainer,
  ApplyClearButtonContainer,
  SaveApplyClearButtonContainer,
  FilterHeader,
};
